class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // PCP (changelog 113): the drawer shelf can name a second list (data-url-related,
    // intent=related) that fills the slots complementary products leave empty. Both
    // are fetched together; complementary items come first, related ones are
    // de-duplicated by product id, capped at data-max.
    const urls = [this.dataset.url];
    if (this.dataset.urlRelated) urls.push(this.dataset.urlRelated);

    Promise.all(urls.map((url) => fetch(url).then((response) => response.text()).catch(() => '')))
      .then((texts) => {
        const lists = texts.map((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          return html.querySelector('cart-recommendations');
        });
        const recommendations = lists[0];

        if (lists.length > 1 && recommendations) {
          const max = parseInt(this.dataset.max, 10) || 6;
          const list = recommendations.querySelector('ul');
          const seen = new Set();
          const items = [];
          lists.forEach((source) => {
            if (!source) return;
            source.querySelectorAll('li[data-product-id]').forEach((li) => {
              if (items.length >= max || seen.has(li.dataset.productId)) return;
              seen.add(li.dataset.productId);
              items.push(li);
            });
          });
          if (list) list.replaceChildren(...items);
        }

        // PCP (changelog 113): the UK top-up shelf is already rendered server-side and
        // re-renders once with the anchor's complementary products (data-swap="changed").
        // Swap only when the cards or the sub-line differ, and never hide it.
        if (this.dataset.swap === 'changed') {
          const sig = (root) =>
            [...root.querySelectorAll('li[data-product-id]')].map((li) => li.dataset.productId).join(',') +
            '|' + ((root.querySelector('.pcp-shelf__sub') || {}).textContent || '').trim();
          if (recommendations && recommendations.querySelector('li') && sig(recommendations) !== sig(this)) {
            this.innerHTML = recommendations.innerHTML;
          }
          return;
        }

        // PCP (changelog 113): hide the panel when nothing comes back, instead of leaving
        // the :empty shimmer placeholder spinning (complementary data is sparse).
        if (recommendations && recommendations.querySelector('li')) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          this.hidden = true;
        }
      })
      .catch((e) => {
        if (this.dataset.swap !== 'changed') this.hidden = true;
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
